import { render, staticRenderFns } from "./multipleXAxis.md?vue&type=template&id=4243fc48&"
import script from "./multipleXAxis.md?vue&type=script&lang=js&"
export * from "./multipleXAxis.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4243fc48')) {
      api.createRecord('4243fc48', component.options)
    } else {
      api.reload('4243fc48', component.options)
    }
    module.hot.accept("./multipleXAxis.md?vue&type=template&id=4243fc48&", function () {
      api.rerender('4243fc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/line/multipleXAxis.md"
export default component.exports